//#region src/modules/ServicePeriods/queries/period-query.ts
function locationAssignedToIds(locationId, locationGroupIds) {
	return [locationId, ...locationGroupIds];
}
function buildLocationServicePeriodQueryArgs(input) {
	return {
		assignedToIds: input.assignedToIds,
		pagination: input.pagination
	};
}
//#endregion
export { buildLocationServicePeriodQueryArgs, locationAssignedToIds };

//# sourceMappingURL=period-query.js.map